import * as React from "react";
import { toINR } from "../../../service/numberFormat";

export interface ILimitsRightColProps {
	payOut?: string;
	marginUtilised?: string;
	realisedMtm?: string;
	unrealisedMtm?: string;
	spanExposure?: string;
	others?: string;
	blocked?: string;
	mfss?: string;
}

const LimitsRightCol: React.FC<ILimitsRightColProps> = props => {
	return (
		<div>
			<div className="row">
				<span className="label">Withdrew (Pay Out)</span>
				<span className="value">₹{toINR(props.payOut, 2)}</span>
			</div>
			<div className="thin_divider" />

			<div className="row">
				<span className="label">Margin Utilised</span>
				<span className="value">₹{toINR(props.marginUtilised, 2)}</span>
			</div>

			{props.realisedMtm && (
				<div className="row thin mg-t15">
					<span className="label">Realised MTM</span>
					<span className="value">₹{toINR(props.realisedMtm, 2)}</span>
				</div>
			)}

			{props.unrealisedMtm && (
				<div className="row thin">
					<span className="label">Unrealised MTM</span>
					<span className="value">₹{toINR(props.unrealisedMtm, 2)}</span>
				</div>
			)}

			{props.spanExposure && (
				<div className="row thin">
					<span className="label">Span + Exposure</span>
					<span className="value">₹{toINR(props.spanExposure, 2)}</span>
				</div>
			)}

			{props.others && (
				<div className="row thin">
					<span className="label">Others</span>
					<span className="value">₹{toINR(props.others, 2)}</span>
				</div>
			)}

			{props.blocked && (
				<>
					<div className="thin_divider" />
					<div className="row">
						<span className="label">Blocked for Third Party</span>
						<span className="value">₹{toINR(props.blocked, 2)}</span>
					</div>
				</>
			)}

			{props.mfss && (
				<div className="row thin mg-t15">
					<span className="label">MFSS Amount</span>
					<span className="value">₹{toINR(props.mfss, 2)}</span>
				</div>
			)}
		</div>
	);
};

export default LimitsRightCol;
